import { useState } from 'react';
import { Outlet, Link, Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth';

const SIDEBAR_ITEMS = [
  { path: '/admin', label: '대시보드', icon: '📊' },
  { path: '/admin/reservations', label: '예약 관리', icon: '📋' },
  { path: '/admin/vehicles', label: '차량 승인', icon: '🚗' },
  { path: '/admin/vehicles/all', label: '전체 차량', icon: '🚙' },
  { path: '/admin/analytics', label: '분석', icon: '📈' },
  { path: '/admin/settlements', label: '정산', icon: '💰' },
  { path: '/admin/config', label: '설정', icon: '⚙️' },
];

export default function AdminLayout() {
  const { user, hasRole, signOut } = useAuthStore();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (!user || !hasRole('admin')) return <Navigate to="/signin" />;

  const closeSidebar = () => setSidebarOpen(false);

  const sidebarContent = (
    <>
      <div className="p-5 border-b border-gray-800">
        <div className="flex items-center justify-between">
          <Link to="/admin" onClick={closeSidebar} className="text-lg font-bold text-white focus:outline-none focus:ring-2 focus:ring-brand-500 rounded">PURPLEMINE Admin</Link>
          <button onClick={closeSidebar} className="lg:hidden text-gray-400 hover:text-white text-xl leading-none transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-brand-500 rounded-lg">&times;</button>
        </div>
        <p className="text-xs text-gray-400 mt-1">{user.name}님</p>
      </div>
      <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
        {SIDEBAR_ITEMS.map(item => (
          <Link
            key={item.path}
            to={item.path}
            onClick={closeSidebar}
            className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-brand-500 ${
              (location.pathname === item.path) || (item.path !== '/admin' && location.pathname.startsWith(item.path))
                ? 'bg-brand-600 text-white'
                : 'text-gray-300 hover:bg-gray-800 hover:text-white'
            }`}
          >
            <span>{item.icon}</span>
            {item.label}
          </Link>
        ))}
      </nav>
      <div className="p-4 border-t border-gray-800">
        <Link to="/" onClick={closeSidebar} className="text-sm text-gray-400 hover:text-white block mb-2 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-brand-500 rounded px-1 -ml-1">
          ← 메인 사이트
        </Link>
        <button onClick={signOut} className="text-sm text-gray-400 hover:text-white transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-brand-500 rounded px-1 -ml-1">
          로그아웃
        </button>
      </div>
    </>
  );

  return (
    <div className="min-h-screen flex">
      {/* Desktop sidebar */}
      <aside className="hidden lg:flex lg:flex-col w-64 bg-gray-900 text-white shrink-0">
        {sidebarContent}
      </aside>

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="fixed inset-0 bg-black/50" onClick={closeSidebar} />
          <aside className="relative w-64 bg-gray-900 text-white flex flex-col z-50 animate-slide-in">
            {sidebarContent}
          </aside>
        </div>
      )}

      {/* Content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Mobile header bar */}
        <div className="lg:hidden flex items-center justify-between bg-white border-b border-gray-200 px-4 h-14 shrink-0">
          <button onClick={() => setSidebarOpen(true)} className="text-gray-700 p-1 rounded-lg transition-colors duration-150 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500">
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
          </button>
          <span className="font-bold text-sm">PURPLEMINE Admin</span>
          <div className="w-6" />
        </div>

        <main className="flex-1 bg-gray-50 p-4 sm:p-6 lg:p-8 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
